export const CONNECTION_ERROR_MESSAGE = "接続に失敗しました\n通信環境を確認の上、再試行してください";

export const PAYMENT_FEE_NOTICE = "記載の料金に加えて別途5%の決済手数料がかかります。";

// 最小年齢
export const MIN_AGE = 18;

// 生年入力の最小
export const MIN_BIRTH_YEAR = 1930;

// 郵便番号の桁数
export const POSTAL_CODE_LENGTH = 7;
